var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_13476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71191 0.896301H14.2879V11.307H3.71191V0.896301Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_13476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1764 6.06601C14.1764 3.21546 11.854 0.896301 8.99943 0.896301C6.14564 0.896301 3.82324 3.21546 3.82324 6.06601C3.82324 8.90845 6.14564 11.2276 8.99943 11.2276C11.854 11.2276 14.1764 8.90845 14.1764 6.06601Z",
    fill: "#2196F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_176_13476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 18,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7217H18V25.1037H0V11.7217Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_176_13476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00683594 20.8088V22.3706C0.00683594 23.8773 1.23405 25.1037 2.74398 25.1037H15.2551C16.7642 25.1037 17.9914 23.8773 17.9914 22.3706V20.8088C17.9914 15.8578 13.9566 11.8287 8.99914 11.8287C4.04167 11.8287 0.00683594 15.8578 0.00683594 20.8088Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFill);
export default __webpack_public_path__ + "static/media/user-fill.c012e36855c329a10b3b6e063ce22f30.svg";
export { ForwardRef as ReactComponent };